import { INSTANCE } from "config"
import { SettingsFeatureType } from "types"

export function isFreshFinance(): boolean {
  return ["freshfinance_ee", "freshfinance_lt"].includes(INSTANCE)
}

export function isPunkfinance(): boolean {
  return ["ee_punkfinance"].includes(INSTANCE)
}

export function isPaymentRequestsCreate(
  features: SettingsFeatureType,
): boolean {
  return features?.payment_requests?.create || false
}

export function isPaymentRequestsPayAll(
  features: SettingsFeatureType,
): boolean {
  return features?.payment_requests?.pay_all || false
}

export function isPaymentSchedulesCreate(
  features: SettingsFeatureType,
): boolean {
  return features?.payment_schedules?.create || false
}

export function isPaymentSchedulesShow(features: SettingsFeatureType): boolean {
  return features?.payment_schedules?.show || false
}

export function isPaymentSchedulesSign(features: SettingsFeatureType): boolean {
  return features?.payment_schedules?.sign || false
}

export function isIssuesCreate(features: SettingsFeatureType): boolean {
  return features?.issues?.create || false
}

export function isDebtContractDownload(features: SettingsFeatureType): boolean {
  return features?.debts?.download || false
}

export function isTermsPDF(features: SettingsFeatureType): boolean {
  return features?.static?.terms?.pdf || false
}

export function isPrivacyPDF(features: SettingsFeatureType): boolean {
  return features?.static?.privacy?.pdf || false
}

export function isCookiePDF(features: SettingsFeatureType): boolean {
  return features?.static?.cookie?.pdf || false
}
